module.exports = __webpack_public_path__ + "img/gateway_signal.3f858567.gif";